import { useEffect } from "react"
import intl from "react-intl-universal"
import { getControlExpired } from "../../../../../services/ciq"

import styles from "./index.module.scss"
import useDataApi from "../../../../../hooks/useDataApi"
import { Flex } from "@stardust-ds/react"
import { useNavigate } from "react-router-dom"

export const RcmpControlExpiredAlert = () => {
  const [oControlExpiredRes, fnControlExpiredReq] = useDataApi(getControlExpired)

  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      await fnControlExpiredReq()
    })()
  }, [])

  if (!oControlExpiredRes?.data?.data?.has_expired_control) return null

  const fnNavigateToControlList = () => {
    navigate("/ciq/list-controls")
  }

  return (
    <Flex
      width="100%"
      alignContent="center"
      justifyContent="center"
      bColor="#ff3541"
      bWidth="1px"
      bRadius="500px"
      className={styles.controlExpiredContainer}
      onClick={fnNavigateToControlList}
    >
      <p>{intl.get("ciq.has_control_expired")}</p>
    </Flex>
  )
}
